import { CANVAS_SIZE, TEXT_CONFIG } from './config';
import { ReceiptData } from './types';

function drawText(ctx: CanvasRenderingContext2D, text: string, config: any) {
  ctx.fillStyle = config.color || '#FFFFFF';
  ctx.font = `${config.fontWeight || 400} ${config.fontSize}px Inter`;
  ctx.textAlign = config.align || 'left';
  ctx.fillText(text, config.x, config.y);
}

export async function generateReceiptImage(
  canvas: HTMLCanvasElement,
  templateUrl: string,
  data: ReceiptData
): Promise<string> {
  const dpr = window.devicePixelRatio || 1;

  canvas.width = CANVAS_SIZE.width * dpr;
  canvas.height = CANVAS_SIZE.height * dpr;

  canvas.style.width = `${CANVAS_SIZE.width}px`;
  canvas.style.height = `${CANVAS_SIZE.height}px`;

  const ctx = canvas.getContext('2d')!;
  ctx.scale(dpr, dpr);
  canvas.width = CANVAS_SIZE.width;
  canvas.height = CANVAS_SIZE.height;
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.src = templateUrl;
  await new Promise((resolve) => (img.onload = resolve));

  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  drawText(ctx, data.amount, TEXT_CONFIG.amount);
  drawText(ctx, data.time, TEXT_CONFIG.time);
  drawText(ctx, data.name, TEXT_CONFIG.name);
  drawText(ctx, data.cuit, TEXT_CONFIG.cuit);
  drawText(ctx, data.cbu, TEXT_CONFIG.cbu);
  drawText(ctx, data.coelsaId, TEXT_CONFIG.coelsaId);
  drawText(ctx, data.transactionId, TEXT_CONFIG.transactionId);

  return canvas.toDataURL('image/png');
}
